var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-card', [_c('v-card-title', [_vm._v("Create from Existing Tables")]), _c('v-card-subtitle', [_vm._v(" Link edge tables with node tables by clicking the "), _c('v-icon', [_vm._v("mdi-link")]), _vm._v(" icon on the desired edge table, and selecting the node table column that you'd like to link it to. ")], 1), _vm.networkCreating ? _c('v-progress-linear', {
    attrs: {
      "indeterminate": ""
    }
  }) : _vm._e(), _c('v-row', {
    attrs: {
      "no-gutters": "",
      "align": "center"
    }
  }, [_c('v-col', {
    staticClass: "ml-3",
    attrs: {
      "cols": "2",
      "align-self": "center"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Network Name",
      "solo": ""
    },
    model: {
      value: _vm.networkName,
      callback: function callback($$v) {
        _vm.networkName = $$v;
      },
      expression: "networkName"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "1",
      "align-self": "center"
    }
  }, [_c('v-btn', {
    staticClass: "ml-2 mb-6",
    attrs: {
      "color": "primary",
      "disabled": !_vm.valid
    },
    on: {
      "click": _vm.createNetwork
    }
  }, [_vm._v(" Create ")])], 1)], 1), _vm.tableSamples.length ? [_c('v-row', {
    staticClass: "ml-3",
    attrs: {
      "no-gutters": ""
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "2"
    }
  }, [_c('v-list', [_c('v-list-item', {
    staticClass: "px-0"
  }, [_c('v-list-item-action', [_c('v-checkbox', {
    attrs: {
      "value": _vm.allTablesVisible
    },
    on: {
      "change": _vm.selectAllTables
    }
  })], 1), _c('v-list-item-subtitle', [_vm._v(" All Tables ")])], 1), _vm._l(_vm.tableSamples, function (sample) {
    return _c('v-list-item', {
      key: sample.table.name,
      staticClass: "px-0"
    }, [_c('v-list-item-action', [_c('v-checkbox', {
      model: {
        value: _vm.tablesVisible[sample.table.name],
        callback: function callback($$v) {
          _vm.$set(_vm.tablesVisible, sample.table.name, $$v);
        },
        expression: "tablesVisible[sample.table.name]"
      }
    })], 1), _c('v-list-item-title', [_vm._v(" " + _vm._s(sample.table.name) + " ")])], 1);
  })], 2)], 1), _c('v-divider', {
    attrs: {
      "vertical": ""
    }
  }), _c('v-col', {
    attrs: {
      "cols": "10"
    }
  }, [_c('v-row', {
    attrs: {
      "no-gutters": "",
      "justify": "start"
    }
  }, _vm._l(_vm.visibleTableSamples, function (sample) {
    return _c('v-card', {
      key: sample.table.name,
      staticClass: "ma-4",
      attrs: {
        "outlined": "",
        "raised": ""
      }
    }, [_c('v-sheet', {
      staticClass: "table-title px-2"
    }, [_c('v-row', {
      attrs: {
        "no-gutters": ""
      }
    }, [_c('span', [_vm._v(_vm._s(sample.table.name))]), _c('v-spacer'), _c('v-switch', {
      staticClass: "ma-0 pa-0",
      attrs: {
        "label": "Edge Table",
        "dark": "",
        "hide-details": "",
        "disabled": _vm.edgeTable !== undefined && _vm.edgeTable.table.name !== sample.table.name,
        "value": _vm.edgeTable !== undefined && _vm.edgeTable.table.name === sample.table.name
      },
      on: {
        "change": function change($event) {
          return _vm.setEdgeTable(sample.table, $event);
        }
      }
    })], 1)], 1), _c('v-data-table', {
      staticClass: "upload-preview",
      attrs: {
        "hide-default-footer": "",
        "hide-default-header": "",
        "headers": sample.headers,
        "items": sample.rows,
        "disable-sort": ""
      },
      scopedSlots: _vm._u([{
        key: "header",
        fn: function fn(_ref) {
          var headers = _ref.props.headers;
          return [_c('thead', {
            attrs: {
              "dark": ""
            }
          }, [_c('tr', _vm._l(headers, function (_ref2) {
            var col = _ref2.value;
            return _c('th', {
              key: "".concat(sample.table.name, ":").concat(col),
              staticStyle: {
                "width": "1px",
                "white-space": "nowrap"
              }
            }, [!_vm.excludedMap[sample.table.name][col] ? _c('v-icon', {
              attrs: {
                "disabled": _vm.checkboxDisabled(sample.table, col),
                "dark": ""
              },
              on: {
                "click": function click($event) {
                  _vm.excludedMap[sample.table.name][col] = true;
                }
              }
            }, [_vm._v(" mdi-checkbox-marked ")]) : _c('v-icon', {
              attrs: {
                "dark": "",
                "disabled": _vm.checkboxDisabled(sample.table, col)
              },
              on: {
                "click": function click($event) {
                  _vm.excludedMap[sample.table.name][col] = false;
                }
              }
            }, [_vm._v(" mdi-checkbox-blank-outline ")]), _c('span', [_vm._v(_vm._s(col))]), _vm.mainTables.some(function (t) {
              return t !== undefined && t.name === sample.table.name;
            }) ? _c('v-menu', {
              attrs: {
                "close-on-content-click": false
              },
              on: {
                "input": function input($event) {
                  _vm.menuOpen = $event;
                }
              },
              scopedSlots: _vm._u([{
                key: "activator",
                fn: function fn(_ref3) {
                  var on = _ref3.on;
                  return [_c('v-icon', _vm._g({
                    class: {
                      'disable-events': _vm.linkDisabled(sample.table)
                    },
                    attrs: {
                      "color": _vm.linkColor(sample.table, col),
                      "dark": ""
                    }
                  }, on), [_vm._v(" mdi-link ")])];
                }
              }], null, true)
            }, [_c('v-card', {
              attrs: {
                "max-height": "30vh"
              }
            }, [_c('v-card-subtitle', {
              staticClass: "py-1 px-2"
            }, [_vm.linkExists(sample.table, col, ['source', 'target']) ? _c('span', [_vm._v(" Remove Link ")]) : _c('span', [_vm._v(" Select Source/Target ")])]), !(_vm.linkExists(sample.table, col, ['source', 'target']) || _vm.selectingSource || _vm.selectingTarget) ? [_c('v-list', {
              staticClass: "my-0 py-0",
              attrs: {
                "dense": ""
              }
            }, [_c('v-list-item', {
              attrs: {
                "disabled": _vm.sourceTable !== undefined
              },
              on: {
                "click": function click($event) {
                  _vm.selectingSource = true;
                }
              }
            }, [_vm._v(" Source ")]), _c('v-list-item', {
              attrs: {
                "disabled": _vm.targetTable !== undefined
              },
              on: {
                "click": function click($event) {
                  _vm.selectingTarget = true;
                }
              }
            }, [_vm._v(" Target ")])], 1)] : [_c('v-list', {
              staticClass: "my-0 py-0",
              attrs: {
                "dense": ""
              }
            }, [_vm.linkExists(sample.table, col, ['source', 'target']) ? [_c('v-list-item', [_vm._v(" " + _vm._s(_vm.getLinkText(sample.table, col, ['source', 'target'])) + " "), _c('v-spacer'), _c('v-btn', {
              attrs: {
                "icon": "",
                "right": ""
              },
              on: {
                "click": function click($event) {
                  $event.stopPropagation();
                  return _vm.removeColumnLink(sample.table, col);
                }
              }
            }, [_c('v-icon', [_vm._v("mdi-close")])], 1)], 1)] : _vm._l(_vm.getOtherTableColumns(sample.table.name), function (otherCol) {
              return _c('v-list-item', {
                key: "".concat(sample.table.name, "-").concat(otherCol.table.name, "-").concat(otherCol.column),
                on: {
                  "click": function click($event) {
                    return _vm.linkSourceOrTargetTable(col, otherCol.table, otherCol.column);
                  }
                }
              }, [_vm._v(" " + _vm._s("".concat(otherCol.table.name, ":").concat(otherCol.column)) + " ")]);
            })], 2)]], 2)], 1) : _vm._e(), _vm.inNetworkTables.some(function (t) {
              return t !== undefined && t.name === sample.table.name;
            }) ? _c('v-menu', {
              attrs: {
                "close-on-content-click": false
              },
              on: {
                "input": function input($event) {
                  _vm.menuOpen = $event;
                }
              },
              scopedSlots: _vm._u([{
                key: "activator",
                fn: function fn(_ref4) {
                  var on = _ref4.on;
                  return [_c('v-icon', _vm._g({
                    class: {
                      'disable-events': _vm.joinDisabled(sample.table, col)
                    },
                    attrs: {
                      "color": _vm.linkColor(sample.table, col, true),
                      "dark": ""
                    }
                  }, on), [_vm._v(" mdi-call-merge ")])];
                }
              }], null, true)
            }, [_c('v-card', {
              attrs: {
                "max-height": "30vh"
              }
            }, [_c('v-card-subtitle', {
              staticClass: "py-1 px-2"
            }, [_vm.linkExists(sample.table, col, ['join']) ? _c('span', [_vm._v(" Remove Link ")]) : _c('span', [_vm._v(" Join From ")])]), _c('v-list', {
              staticClass: "my-0 py-0",
              attrs: {
                "dense": ""
              }
            }, [_vm.linkExists(sample.table, col, ['join']) ? [_c('v-list-item', [_vm._v(" " + _vm._s(_vm.getLinkText(sample.table, col, ['join'])) + " "), _c('v-spacer'), _c('v-btn', {
              attrs: {
                "icon": "",
                "right": ""
              },
              on: {
                "click": function click($event) {
                  $event.stopPropagation();
                  return _vm.removeColumnLink(sample.table, col, true);
                }
              }
            }, [_c('v-icon', [_vm._v("mdi-close")])], 1)], 1)] : _vm._l(_vm.getOtherTableColumns(sample.table.name), function (otherCol) {
              return _c('v-list-item', {
                key: "".concat(sample.table.name, "-").concat(otherCol.table.name, "-").concat(otherCol.column),
                on: {
                  "click": function click($event) {
                    return _vm.joinTable(sample.table, col, otherCol.table, otherCol.column);
                  }
                }
              }, [_vm._v(" " + _vm._s("".concat(otherCol.table.name, ":").concat(otherCol.column)) + " ")]);
            })], 2)], 1)], 1) : _vm._e()], 1);
          }), 0)])];
        }
      }, {
        key: "item",
        fn: function fn(_ref5) {
          var item = _ref5.item,
              headers = _ref5.headers;
          return [_c('tr', _vm._l(headers, function (header) {
            return _c('td', {
              key: header.value,
              class: _vm.getColumnItemClass(sample.table, header.value),
              staticStyle: {
                "width": "1px",
                "white-space": "nowrap"
              }
            }, [_vm._v(" " + _vm._s(_vm.columnItemText(item, header.value)) + " ")]);
          }), 0)];
        }
      }], null, true)
    })], 1);
  }), 1)], 1)], 1)] : _vm._e()], 2);
}
var staticRenderFns = []

export { render, staticRenderFns }